import * as React from 'react';

import { LinkButton, useDeviceType } from '@cian/ui-kit';
import { IExtraBtnProps } from '../../../../containers/QuizCompletedContainer/types';

export const CloseWebview: React.FC<IExtraBtnProps> = ({ onClick }) => {
  const deviceType = useDeviceType();

  return (
    <LinkButton href="/close_webview" fullWidth={deviceType !== 'desktop'} onClick={onClick}>
      Хорошо
    </LinkButton>
  );
};

CloseWebview.displayName = 'CloseWebview';
